module.exports = __webpack_public_path__ + "img/kakeibo-budget-planner_B09K1XG7RD.adb9cf9e.jpg";